import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {File} from 'app/entities/file.entity';
import {AppService} from 'app/services/app.service';
import {GalleryModalComponent} from '../../shared/galleryModal/item';
import {DomSanitizer} from '@angular/platform-browser';
import {BlockElementGalleryFilesViewList, BlockElementGalleryImagesViewList} from 'app/entities/enums';
import {HelperService} from 'app/services/helper.service';

@Component({
  selector: 'app-file-items',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class FileItemsComponent implements OnInit {

  appService: AppService;
  sanitizer: DomSanitizer;

  // @todo remove file-slider-items and use this component instead
  @Input() imageView: BlockElementGalleryImagesViewList = 'small-grid';
  @Input() docView: BlockElementGalleryFilesViewList = 'grid';
  @Input() files: File[] = [];
  @Input() isChatMode = false;
  @Input() disabled = false;

  @Output() deleteClick: EventEmitter<any> = new EventEmitter<any>();
  deleteClickUsed = false;

  constructor(
    appService: AppService,
    sanitizer: DomSanitizer
  ) {

    this.appService = appService;
    this.sanitizer = sanitizer;
  }

  ngOnInit(): void {
    this.deleteClickUsed = this.deleteClick.observers.length > 0;
  }


  openFileModal(file: File) {
    if(this.disabled) {
      return;
    }
    if (file.fileType() !== 'doc') {
      const f = this.files.filter((item) => item.fileType() !== 'doc');
      const i = f.findIndex((item) => item.fileUrl() === file.fileUrl());

      this.appService.appModalService.openGalleryModal(f, i);
    } else {
      HelperService.openLink(file.fileUrl());
    }
  }

  onDeleteClick(index) {
    if (this.deleteClick) {
      this.deleteClick.emit(index);
    }
  }

  getClasses(file: File) {
    const classes = [];
    if (file.fileType() === 'doc') {
      if (this.docView === 'grid') {
        classes.push('col-half');
      }

      if (this.docView === 'list') {
        classes.push('col-23');
        classes.push('type-line');
      }

      if (this.docView === 'scroll') {
        classes.push('col-scroll');
      }
    } else {
      if (this.imageView === 'small-grid') {
        if (this.docView === 'scroll') {
          classes.push('col-scroll');
        } else {
          classes.push('col-half');
        }
      }

      if (this.imageView === 'big-grid') {
        classes.push('col-23');
        classes.push('image-big-grid');
      }
    }

    return classes;
  }
}
